module.exports = __webpack_public_path__ + "img/mobile_access_biometric.05845ef0.svg";